import { HTMLAttributes } from 'react';
import { GridItem } from '@/dashboard/mui/styledComponent';
import { Box, Grid, Typography } from '@mui/material';
import clsx from 'clsx';

type PolicyPauseDayInfoProps = HTMLAttributes<HTMLDivElement> & {
  info?: any;
  type?: number; // 1. common 2. left & paused
};

const PolicyPauseDayInfo = (props: PolicyPauseDayInfoProps) => {
  const {
    info: {
      days_left,
      days_used,
      pauses_left,
      pauses_used,
      total_days_per_year,
      total_pauses_per_year,
      total_days,
    } = {},
    className,
    type = 1,
  } = props;

  let infoList = [];
  switch (type) {
    case 2:
      infoList = [
        {
          content: 'Days left',
          days: days_left,
          backgroundColor: '#D5F3E2',
          textColor: '#1CB258',
        },
        {
          content: 'Days used',
          days: days_used,
          backgroundColor: '#E2E2E2',
          textColor: '#707070',
        },
        {
          content: 'Total days per year',
          days: total_days_per_year,
          backgroundColor: '#DEF4FF',
          textColor: '#43A7D2',
        },
        {
          content: 'Pauses left',
          days: pauses_left,
          backgroundColor: '#D5F3E2',
          textColor: '#1CB258',
        },
        {
          content: 'Pauses used',
          days: pauses_used,
          backgroundColor: '#E2E2E2',
          textColor: '#707070',
        },
        {
          content: 'Total pauses per year',
          days: total_pauses_per_year,
          backgroundColor: '#DEF4FF',
          textColor: '#43A7D2',
        },
      ];
      break;
    default:
      infoList = [
        {
          content: 'Days left',
          days: days_left,
          backgroundColor: '#D5F3E2',
          textColor: '#1CB258',
        },
        {
          content: 'Days used',
          days: days_used,
          backgroundColor: '#E2E2E2',
          textColor: '#707070',
        },
        {
          content: 'Total days available',
          days: total_days,
          backgroundColor: '#DEF4FF',
          textColor: '#43A7D2',
        },
      ];
      break;
  }

  return (
    <Grid container className={clsx(className)}>
      {infoList.map((item) => {
        return (
          <Grid item xs={12} md={4} key={item.content} className="mb-3">
            <GridItem>
              <Box className="flex flex-row items-center">
                <Box
                  style={{ backgroundColor: item.backgroundColor }}
                  className="flex h-10 w-10 items-center justify-center rounded"
                >
                  <Typography className="font-bold" variant="h6">
                    {item.days}
                  </Typography>
                </Box>
                <Typography className="ml-2" variant="body2">
                  {item.content}
                </Typography>
              </Box>
            </GridItem>
          </Grid>
        );
      })}
      <div>
        <p className="py-2 text-xs text-[#707070]">
          When you purchased cover we advised you of how the pause process
          operates and results in a reduction in your monthly payments. Please
          find below a reminder of how the process works in practice.
        </p>
        <p className="py-2 text-xs font-bold italic text-[#707070]">
          As an example, if prior to the pause period, your monthly payments
          were £50, including IPT, these will reduce to £30, including IPT, once
          your policy is un-paused.
        </p>
      </div>
    </Grid>
  );
};

export default PolicyPauseDayInfo;
